import Image from "components/common/images/Image";
import { CorpDetailModel } from "models";
import { CommonFileModel } from "models/CommonFileModel";
import React from "react";
import { Link } from "react-router-dom";
import { Utils } from "utils";

type PROPS = {
  data: CorpDetailModel;
  isAdminCorp?: boolean;
  withMyItem?: boolean;
};

/** 販売中の商品 */
const CorpDetailSaleItems: React.FC<PROPS> = (props) => {
  const data = props.data;

  const [saleItems, setSaleItems] = React.useState<
    ({
      item_cd: string;
      item_name: string;
      is_discretionary_price: boolean;
      sale_price: string;
      item_main_image: CommonFileModel;
    } | null)[]
  >([]);

  React.useEffect(() => {
    const tmp = props.data.sale_item.concat();
    if (tmp.length > 0) {
      while (tmp.length < 4) {
        (tmp as any).push(null);
      }
      setSaleItems(tmp);
    }
  }, [props.data]);

  if (saleItems.length === 0) {
    return <></>;
  }

  return (
    <div className="py-8">
      <div className="border-b mb-4 flex justify-between items-end">
        <div className="font-bold text-2xl">販売中の商品</div>
        <Link
          to={props.withMyItem ? '/exhibit-list?get_count=10' : `/item-list?keyword=${data.corp_name}&corp_id=${data.corp_id}&get_count=10`}
          className="text-jhk-blue hover:underline"
        >
          &gt; 全{data.sale_item_max_count}件を見る
        </Link>
      </div>
      <div className="w-full flex gap-4">
        {saleItems.map((item, index) => {
          if (!item) {
            return <div key={index} className="flex-1"></div>;
          }
          return (
            <Link
              key={index}
              className="flex-1 overflow-hidden"
              to={`/item-detail/${item.item_cd}`}
            >
              <Image
                data={item.item_main_image}
                height="calc(calc(98vw - 20rem) / 4)"
                default="item.png"
              />
              <div className="hover:underline whitespace-nowrap overflow-hidden text-ellipsis">
                {item.item_name}
              </div>
              <div className="text-right">
                {item.is_discretionary_price ? (
                  <span className="font-bold text-lg mx-4">-</span>
                ) : (
                  <>
                    <span className="font-bold text-lg">
                      {Utils.addComma(item.sale_price)}
                    </span>
                    円<span className="text-sm">(税抜)</span>
                  </>
                )}
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default CorpDetailSaleItems;
